import { push } from 'redux-first-history';
import { put, takeEvery } from 'redux-saga/effects';

import { config } from '@/config/config';
import { logger } from '@/config/logger';
import { api } from '@/modules/api/fetcher';
import { actions as messagesActions } from '@/modules/messages';
import { actions as modalsActions } from '@/modules/modals';

import { REMOVE_SECRET_MODAL_KEY } from '../../constants';
import { removeSearchHistory, removeSecret, removeSecretFailure, removeSecretSuccess } from '../actions';

function* handler({ meta }: ReturnType<typeof removeSecret>) {
    try {
        yield* api().delete(config.api.secret, {
            uriParams: {
                id: meta.id,
            },
        });

        yield put(removeSecretSuccess(meta.id));
        yield put(push(config.routes.home));

        yield put(removeSearchHistory(meta.id));

        yield put(
            messagesActions.displaySuccessMessage({
                message: { id: 'success.secrets.remove' },
            }),
        );
    } catch (e) {
        yield put(
            messagesActions.displayErrorMessage({
                message: { id: 'error.secrets.remove' },
            }),
        );
        logger.error(e);

        yield put(removeSecretFailure(meta.id, e));
    } finally {
        yield put(modalsActions.setModalVisibility(REMOVE_SECRET_MODAL_KEY, false));
    }
}

export default function* () {
    yield takeEvery(removeSecret.toString(), handler);
}
